import { Link } from "react-router-dom";
import { Star } from "lucide-react";
import { fileUrl } from "../../lib/api";

const LABEL = { cricket: "Cricket", casino: "Casino", general: "Guide" };

export const FeaturedPost = ({ p, cdn }) => (
  <Link to={`/blog/${p.slug}`} data-testid="blog-featured"
    className="group relative mb-12 grid overflow-hidden rounded-3xl border border-[#D4AF37]/50 bg-[#0F1015] shadow-[0_0_60px_-20px_rgba(212,175,55,0.45)] transition-transform hover:-translate-y-1 lg:grid-cols-[1.25fr_1fr]">
    <div className="pointer-events-none absolute inset-0 rounded-3xl ring-1 ring-inset ring-[#F3D77A]/20" />
    <div className="relative aspect-[16/9] overflow-hidden bg-[#12141C] lg:aspect-auto lg:min-h-[380px]">
      {p.featured_image && <img src={fileUrl(p.featured_image, cdn)} alt={p.featured_alt || p.title} fetchpriority="high"
        className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />}
      <div className="absolute inset-0 bg-gradient-to-t from-[#0F1015] via-transparent to-transparent lg:bg-gradient-to-r lg:from-transparent lg:via-transparent lg:to-[#0F1015]" />
    </div>
    <div className="relative flex flex-col justify-center p-7 sm:p-10">
      <span className="inline-flex w-fit items-center gap-1.5 rounded-full bg-gradient-to-b from-[#F3D77A] to-[#D4AF37] px-3 py-1 text-[10px] font-bold uppercase tracking-[0.2em] text-black" data-testid="blog-featured-badge">
        <Star size={11} fill="currentColor" /> Featured
      </span>
      <p className="mt-5 text-xs uppercase tracking-widest text-[#D4AF37]">
        {LABEL[p.category] || "Guide"} · {new Date(p.published_at || p.created_at).toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" })} · {p.reading_minutes || 1} min read
      </p>
      <h2 className="mt-3 font-serif text-2xl font-bold leading-tight text-white sm:text-3xl" data-testid="blog-featured-title">{p.title}</h2>
      <p className="mt-4 line-clamp-3 text-sm text-zinc-400 sm:text-base">{p.excerpt || p.seo?.meta_description}</p>
      <span className="btn-gold mt-7 w-fit !py-2.5">Read article</span>
    </div>
  </Link>
);
